import React from "react";
import contactBorder from "@assets/images/borders/contactBorder.webp";

const SkeletonPayment: React.FC = () => {
  return (
    <div className="grid grid-cols-2 max-lg:grid-cols-1 max-md:grid-cols-1 gap-5 max-h-[600px] max-md:max-h-full overflow-auto">
      {[1, 2, 3, 4, 5].map((val) => (
        <div key={val}>
          <div className="relative py-5 px-8 max-md:p-4 max-md:border max-md:border-[#89D9EE] max-md:rounded-xl">
            <img
              className="absolute top-0 left-0 size-full max-md:hidden"
              src={contactBorder}
              alt="Contact-border"
            />
            <div className="relative">
              <div className="flex items-center justify-between">
                <div className="h-10 w-full skeleton mr-3"></div>
                <div className="flex gap-3">
                  <div className="flex items-center duration-150 h-10 w-12 skeleton"></div>
                  <div className="h-10 w-10 skeleton"></div>
                </div>
              </div>
              <div className="mt-3 h-10 w-full skeleton"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonPayment;
